export const ORDER_RESET = "ORDER_RESET";
export const ORDER_NEW = "ORDER_NEW";
export const ORDER_DISCOUNT = "ORDER_DISCOUNT";
